import React from 'react';
import { TimeZoneFormat } from '@shared/utils/constants';
import type { CreateItineraryEntryRequest } from '@api/features/ops/createItineraryEntry';
import type { DatePickerValue } from '@client/components/DatePicker';
import {
	ItineraryPortCallDto,
	ItinerarySeaPassageDto,
} from '@client/screens/estimates/details/helpers/types';
import getPortAndRangeOptions from '@client/utils/getPortAndRangeOptions';
import {
	PortAwareFormDatePicker,
	TIME_ZONE_FORMAT_OPTIONS,
} from '../components/PortAwareDatePicker';

export type NewPortCallFormValues = {
	portId: number;
	timeZoneFormat?: TimeZoneFormat;
	estimatedDepartureDate?: DatePickerValue;
	actualDepartureDate?: DatePickerValue;
	robs?: CreateItineraryEntryRequest['robs'];
};

const getFormFields = (
	portOptions: ReturnType<typeof getPortAndRangeOptions>,
	entries: Array<ItinerarySeaPassageDto | ItineraryPortCallDto>,
	defaultTimeZoneFormat: TimeZoneFormat,
) => [
	{
		label: 'Port',
		required: true,
		name: 'portId',
		type: 'select',
		options: portOptions,
		inputProps: { showSearch: true },
	},
	...(entries.length === 0 ? [{
		label: 'Time format',
		required: true,
		name: 'timeZoneFormat',
		type: 'select',
		options: TIME_ZONE_FORMAT_OPTIONS,
		inputProps: {},
	}, {
		label: 'Est. Departure Date',
		required: true,
		name: 'estimatedDepartureDate',
		type: 'custom',
		renderInput: ({ form }: any) => (
			<PortAwareFormDatePicker
				formInstance={form}
				portFieldName="portId"
				timeZoneFormatFieldName="timeZoneFormat"
				defaultTimeZoneFormat={defaultTimeZoneFormat}
				time
				allowClear={false}
			/>
		),
	}] : []),
];

export default getFormFields;
